module.exports = __webpack_public_path__ + "static/media/oberflex-cheneceruse-2560x1440.7075886c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneceruse-2560x1440.jpg
// module id = 987
// module chunks = 37